import React from 'react';
import AppSystemTrackDataGrid from './AppSystemTrackDataGrid';

const AppSystemTrackPage = ({ appSystemTrackData }) => {

    console.log("In AppSystemTrackPage after querystring", appSystemTrackData);

    if (!appSystemTrackData) {
        return <div>No data available</div>;
    }

    return (
        <div className='ReactModal__Content'> 
            <h1 className='transaction-status-header'>App System Track Information</h1>
            {/* Optional Syntax Highlighting */}
            {/* <div
                className="json-container"
                dangerouslySetInnerHTML={{ __html: syntaxHighlight(JSON.stringify(appSystemTrackData, null, 2)) }}
            /> */}
            <AppSystemTrackDataGrid data={appSystemTrackData} />
           
        </div>
    );
};

export default AppSystemTrackPage;
